"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkForAllStill = void 0;
var minigolfPhysics_rapier_loader_sidecar_1 = require("../physics/minigolfPhysics_rapier_loader-sidecar");
var minigolfGameState_sidecar_1 = require("../simulation/minigolfGameState-sidecar");
var minigolfCreatures_sidecar_1 = require("./minigolfCreatures-sidecar");
var minigolfEntitiesUtils_sidecar_1 = require("./minigolfEntitiesUtils-sidecar");
var checkForAllStill = function () {
    // let phys = physics_rapier_loader.get()
    var allStill = true;
    var objs = minigolfCreatures_sidecar_1.minigolfCreatures.getAll();
    for (var i = 0; i < objs.length; i++) {
        var obj = objs[i];
        if (obj.isDead)
            continue;
        if (!minigolfEntitiesUtils_sidecar_1.minigolfEntitiesUtils.checkIsStill(obj)) {
            allStill = false;
            break;
        }
    }
    if (allStill) {
        minigolfGameState_sidecar_1.minigolfGameState.get().allStillTime +=
            minigolfPhysics_rapier_loader_sidecar_1.minigolfPhysics_rapier_loader.timestep;
    }
    else {
        minigolfGameState_sidecar_1.minigolfGameState.get().allStillTime = 0;
    }
    var combinedAllStill = (allStill && minigolfGameState_sidecar_1.minigolfGameState.get().allStillTime > 1 / 30) || false;
    minigolfGameState_sidecar_1.minigolfGameState.get().isAllStill = combinedAllStill;
};
exports.checkForAllStill = checkForAllStill;
